import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import { processDate } from 'utils/helpers/functions';
import styles from 'components/BlogPosts/BlogPost/BlogPost.module.scss';

const cn = classNames.bind(styles);

interface BlogPostProps {
  id: number;
  url: string;
  image: string;
  tag: string;
  date: string;
  title: string;
};

const BlogPost: FC<BlogPostProps> = ({ id, url, image, tag, date, title }): ReactElement => {
  return (
    <div
      className={cn('blog-post')}
      key={id}
    >
      <Link
        className={cn('blog-post__link')}
        href={`/blog/${url}`}
      >
        <div className={cn('blog-post__image-box')}>
          <img
            className={cn('blog-post__image')}
            src={image}
            width="374"
            height="184"
            alt="Blog 1"
            loading="lazy"
          />
        </div>

        <div className={cn('blog-post__container')}>

          <div className={cn('blog-post__info')}>
            <span className={cn('blog-post__tag')}>{tag}</span>
            <svg
              className={cn('blog-post__divider')}
              width="4"
              height="5"
              viewBox="0 0 4 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="2"
                cy="2.74219"
                r="2"
                fill="white"
              />
            </svg>
            <span className={cn('blog-post__date')}>{processDate(date)}</span>
          </div>

          <h4 className={cn('blog-post__title')}>{title}</h4>
        </div>

      </Link>
    </div>
  );
};

export { BlogPost };